import type { AbstractIntlMessages } from 'use-intl';

import type { Locale } from './locales';

/**
 * Dynamically imports all namespace JSONs for the given locale and merges
 * them into a single messages object keyed by namespace name.
 *
 * This is the single source of truth for which namespaces exist.
 * Add new namespaces here (and create the corresponding JSON files for every
 * locale) when a new independent screen or domain area is introduced.
 */
export async function loadMessages(locale: Locale): Promise<AbstractIntlMessages> {
  const [common, auth, errors, registration, newCase, settings] = await Promise.all([
    import(`../../messages/${locale}/common.json`),
    import(`../../messages/${locale}/auth.json`),
    import(`../../messages/${locale}/errors.json`),
    import(`../../messages/${locale}/registration.json`),
    import(`../../messages/${locale}/newCase.json`),
    import(`../../messages/${locale}/settings.json`),
  ]);

  return {
    common: common.default as AbstractIntlMessages,
    auth: auth.default as AbstractIntlMessages,
    errors: errors.default as AbstractIntlMessages,
    registration: registration.default as AbstractIntlMessages,
    newCase: newCase.default as AbstractIntlMessages,
    settings: settings.default as AbstractIntlMessages,
  };
}
